import axios from "axios";
import { dispatch } from "store";
import { hideLoader, showLoader } from "store/reducers/dashboard";

// Create an instance of Axios
const v1Api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_PRIVATE_BASE_URL,
});

// Axios request interceptor
v1Api.interceptors.request.use(
  (config) => {
    // set the loader state to true to turn on the loading animation
    dispatch(showLoader());

    const accessToken = localStorage.getItem("serviceToken");

    config.headers["Content-Type"] = "application/json; charset=utf-8";
    config.headers["x-api-key"] = process.env.REACT_APP_X_API_KEY;
    config.headers["Authorization"] = `JWT ${accessToken}`;
    config.headers["service"] = "Web Admin";

    return config;
  },
  (error) => {
    // hide loader
    dispatch(hideLoader());

    return Promise.reject(error);
  }
);

v1Api.interceptors.response.use(
  (response) => {
    // hide loader
    dispatch(hideLoader());

    return response;
  },
  (error) => {
    // hide loader
    dispatch(hideLoader());

    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services"
    );
  }
);

export default v1Api;
